export default __webpack_public_path__ + "static/media/avatar_arrow_boy3.8143e905.mp3";